import axios, { AxiosError, AxiosResponse } from 'axios';
import { message } from 'antd';
import { useAuthStore } from '@/stores/auth';

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
  timeout: 30_000,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  const token = useAuthStore.getState().accessToken;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  // 后端统一响应包装: { code, message, timestamp, data, pagination? }
  // 这里 unwrap 一层, 业务侧拿到的就是真实数据
  (resp: AxiosResponse) => {
    const body = resp.data;
    if (body && typeof body === 'object' && 'code' in body && 'data' in body) {
      if (body.code !== 200 && body.code !== 0) {
        message.error(body.message || '请求失败');
        return Promise.reject(body);
      }
      // 分页响应保留 pagination 元信息
      if (body.pagination) {
        return { ...body, results: body.data } as any;
      }
      return body.data;
    }
    return body;
  },
  async (err: AxiosError<any>) => {
    if (err.response?.status === 401) {
      // TODO: refresh token + retry, 当前直接登出
      useAuthStore.getState().logout();
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    } else {
      const detail =
        err.response?.data?.message ||
        err.response?.data?.detail ||
        err.message ||
        '网络错误';
      message.error(detail);
    }
    return Promise.reject(err);
  },
);
